module.exports = __webpack_public_path__ + "media/images/div_lens/masonry-img-6-3caeded5014ad127884b386a4cc7ed0f.png";